export default __webpack_public_path__ + "static/media/Stain-Removers-mob.8fdefc53.jpg";